/**
 * Gravity Services Accordion JavaScript - SlideUp/SlideDown Animation
 */
document.addEventListener('DOMContentLoaded', function() {
    // Get all accordion items
    const accordionItems = document.querySelectorAll('.gravity-services-accordion__item');
    
    accordionItems.forEach(function(item) {
        const toggle = item.querySelector('.gravity-services-accordion__item-button');
        const contentWrapper = item.querySelector('.gravity-services-accordion__item-content-wrapper');
        const icon = item.querySelector('.gravity-services-accordion__icon');
        
        if (toggle && contentWrapper) {
            // Optimized function to get content height - fast and accurate
            function getContentHeight() {
                const currentHeight = contentWrapper.style.height;
                const currentTransition = contentWrapper.style.transition;
                
                // Quick measurement: disable transition, set auto, measure, restore
                contentWrapper.style.transition = 'none';
                contentWrapper.style.height = 'auto';
                const height = contentWrapper.scrollHeight;
                contentWrapper.style.height = currentHeight;
                contentWrapper.style.transition = currentTransition;
                
                // Return height with padding-bottom (24px) + buffer (10px)
                return height; // scrollHeight + padding-bottom + buffer
            }
            
            // Set initial state for expanded items (on page load)
            if (item.classList.contains('gravity-services-accordion__item--expanded')) {
                requestAnimationFrame(function() {
                    const height = getContentHeight();
                    contentWrapper.style.height = height + 'px';
                });
            }
            
            toggle.addEventListener('click', function() {
                // Toggle the expanded class
                const isExpanded = item.classList.contains('gravity-services-accordion__item--expanded');
                const iconAnima = item.querySelector('.gravity-services-accordion__icon');
                
                if (isExpanded) {
                    // SlideUp - Collapse
                    const currentHeight = contentWrapper.scrollHeight;
                    
                    // Set current height explicitly for smooth transition
                    contentWrapper.style.height = currentHeight + 'px';
                    contentWrapper.style.opacity = '1';
                    contentWrapper.style.paddingBottom = '1.5rem';
                    
                    // Force reflow
                    void contentWrapper.offsetHeight;
                    
                    // Remove expanded class
                    item.classList.remove('gravity-services-accordion__item--expanded');
                    
                    // Animate to 0 (slideUp)
                    requestAnimationFrame(function() {
                        contentWrapper.style.height = '0';
                        contentWrapper.style.opacity = '0';
                        contentWrapper.style.paddingBottom = '0';
                    });
                    
                    toggle.setAttribute('aria-expanded', 'false');
                    if (iconAnima.classList.contains('has-animation')) {
                        iconAnima.classList.remove('has-animation');
                    } else {
                        iconAnima.classList.add('has-animation');
                    }
                } else {
                    // SlideDown - Expand
                    // (and optionally close others - uncomment next lines for accordion behavior)
                    // accordionItems.forEach(function(otherItem) {
                    //     if (otherItem !== item && otherItem.classList.contains('gravity-services-accordion__item--expanded')) {
                    //         const otherToggle = otherItem.querySelector('.gravity-services-accordion__toggle');
                    //         const otherContent = otherItem.querySelector('.gravity-services-accordion__item-content-wrapper');
                    //         if (otherToggle && otherContent) {
                    //             const otherHeight = otherContent.scrollHeight;
                    //             otherContent.style.height = otherHeight + 'px';
                    //             void otherContent.offsetHeight;
                    //             otherItem.classList.remove('gravity-services-accordion__item--expanded');
                    //             requestAnimationFrame(function() {
                    //                 otherContent.style.height = '0';
                    //                 otherContent.style.opacity = '0';
                    //                 otherContent.style.paddingBottom = '0';
                    //             });
                    //             otherToggle.setAttribute('aria-expanded', 'false');
                    //         }
                    //     }
                    // });
                    
                    // Add expanded class first
                    item.classList.add('gravity-services-accordion__item--expanded');
                    
                    // Set initial state for animation
                    contentWrapper.style.height = '0';
                    contentWrapper.style.opacity = '0';
                    contentWrapper.style.paddingBottom = '0';
                    
                    // Get target height immediately (no setTimeout, no lag)
                    const targetHeight = getContentHeight() + 24;
                    
                    // Animate to target height in single requestAnimationFrame - smooth and fast
                    requestAnimationFrame(function() {
                        contentWrapper.style.height = targetHeight + 'px';
                        contentWrapper.style.opacity = '1';
                        contentWrapper.style.paddingBottom = '1.5rem';
                    });

                    if (!iconAnima.classList.contains('has-animation')) {
                        iconAnima.classList.add('has-animation');
                    } else {
                        iconAnima.classList.remove('has-animation');
                    }
                    
                    toggle.setAttribute('aria-expanded', 'true');
                }
            });
            
            // Add hover functionality to toggle has-animation class on icon
            if (icon && window.innerWidth >= 1199) {
                item.addEventListener('mouseenter', function() {
                    if (icon.classList.contains('has-animation')) {
                        icon.classList.remove('has-animation');
                    } else {
                        icon.classList.add('has-animation');
                    }
                });
                
                item.addEventListener('mouseleave', function() {
                    if (icon.classList.contains('has-animation')) {
                        icon.classList.remove('has-animation');
                    } else {
                        icon.classList.add('has-animation');
                    }
                });
            }
        }
    });
});